// app/javascript/components/shared/ui/Input.js
import React, { forwardRef } from "react"
import { cva } from "class-variance-authority"
import clsx from "clsx"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const inputVariants = cva(
  "w-full rounded-md text-slate-900 outline-none disabled:opacity-60 disabled:cursor-not-allowed placeholder:text-slate-400",
  {
    variants: {
      variant: {
        default: "border border-slate-300 bg-white hover:border-slate-400 focus:border-brand-500 focus:ring-[3px] focus:ring-brand-500/20",
        inline:  "border border-transparent bg-transparent hover:border-slate-200 focus:border-brand-500 focus:bg-white focus:ring-[3px] focus:ring-brand-500/20",
        search:  "border border-slate-200 bg-white focus:border-brand-500 focus:ring-[3px] focus:ring-brand-500/20",
      },
      size: {
        sm: "h-8 text-xs",
        md: "h-9 text-sm",
        lg: "h-10 text-sm",
      },
      align: {
        left:   "text-left",
        right:  "text-right tabular-nums",
        center: "text-center",
      },
    },
    compoundVariants: [
      { variant: "default", size: "sm", class: "px-2" },
      { variant: "default", size: "md", class: "px-2" },
      { variant: "default", size: "lg", class: "px-3" },

      { variant: "inline",  size: "sm", class: "px-2" },
      { variant: "inline",  size: "md", class: "px-2" },
      { variant: "inline",  size: "lg", class: "px-3" },

      { variant: "search",  size: "sm", class: "pl-8 pr-2" },
      { variant: "search",  size: "md", class: "pl-9 pr-3" },
      { variant: "search",  size: "lg", class: "pl-9 pr-3" },
    ],
    defaultVariants: { variant: "default", size: "md", align: "left" },
  }
)

const Input = forwardRef(({ variant, size, align, leadingIcon, className, ...props }, ref) => {
  const inputEl = (
    <input
      ref={ref}
      className={clsx(inputVariants({ variant, size, align }), className)}
      {...props}
    />
  )

  if (!leadingIcon) return inputEl

  return (
    <div className="relative">
      <FontAwesomeIcon
        icon={leadingIcon}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-xs pointer-events-none"
      />
      {inputEl}
    </div>
  )
})
Input.displayName = "Input"

export default Input
